module.exports = "<svg viewBox=\"0 0 299.2 111.4\"><path d=\"M49.9 0C22.3 0 0 22.3 0 49.9s22.3 49.9 49.9 49.9V80.9c-17.1 0-31-13.9-31-31s13.9-31 31-31 31 13.9 31 31v31h-31v18.9h49.9V49.9C99.7 22.4 77.4.1 49.9 0z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/icon-humaniore.svg
// module id = 288
// module chunks = 1